package org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.price_tab.component

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.put
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.media_center.tabs.media.TimeIntervalEnum
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_price.PriceTypeEnum
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_price.special_price.GetSpecialPrice
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.calendar.MonthModel
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.domain.util.extractDate
import org.hs_soft.runmynesto.domain.util.getYearsData
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.domain.util.monthModelToDateString
import org.hs_soft.runmynesto.pages.components.CustomDropDown
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.DropDownItem
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.product_general_tab.component.Price
import org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.product_general_tab.component.PriceInCafe
import org.hs_soft.runmynesto.pages.home.sub_page.template.component.tabs.tab_general.component.date_picker.DatePickerDialog
import org.hs_soft.runmynesto.pages.home.sub_page.template.component.tabs.tab_general.component.select_days.SelectDays
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.px

@Composable
fun SelectedPrice(
    windowSizeMode: WindowSizeModeEnum,
    selectedPrice: GetSpecialPrice,
    profileCountryId:String,
    priceLevels: List<String?>?,
    onUpdatePriceInfo:(String,dynamic)->Unit,
)
{
    Column(
        modifier = Modifier
    )
    {
        SpanText(
            text = PriceTypeEnum.entries.find {
                it.value==selectedPrice.type
            }?.title?:"",
            modifier = Modifier
                .margin(bottom = Dimen.largePadding)
                .fontSize(FontSizes.extraExtraLargeFontSize)
                .color(Theme.TextPrimary.rgb)
                .fontWeight(FontWeight.Medium)
                .fontFamily(FontFamily.Jakarta)
        )

        GeneralPriceInfo(
            windowSizeMode=windowSizeMode,
            selectedPrice=selectedPrice,
            updateInfo={ title:String,value:dynamic->
                onUpdatePriceInfo(title,value)
            }
        )

        when(selectedPrice.type){
            PriceTypeEnum.INDIVIDUAL_PRICE.value->{
                Prices(
                    windowSizeMode = windowSizeMode,
                    selectedPrice =selectedPrice,
                    priceLevels = priceLevels,
                    profileCountryId = profileCountryId,
                )
            }
            PriceTypeEnum.DISCOUNT.value->{
                Discount(
                    selectedPrice =selectedPrice,
                    updateInfo = { title: String, value: dynamic ->
                        onUpdatePriceInfo(title, value)
                    }
                )
            }
        }



    }




}

@Composable
private fun Discount(
    selectedPrice: GetSpecialPrice,
    updateInfo: (String, dynamic) -> Unit
)
{
    CustomEditText(
        value =selectedPrice.actionDiscount.toString(),
        width = Dimen.semiLargeEditTextWidth,
        label = Strings.current().discount+"%",
        inputType = InputType.Number,
        isRequired = true,
        onFocusOut = {
            if (it.toInt()<=100)
                updateInfo(ApiUtils.Field.actionDiscount,it.toInt())
        },
        onFocusIn = {},
        onInputChange = { it,validation ->

        }
    )
}

@Composable
private fun Prices(
    windowSizeMode: WindowSizeModeEnum,
    selectedPrice: GetSpecialPrice,
    profileCountryId:String,
    priceLevels: List<String?>?,
) {


    Column()
    {
        MediumContentTitle(
            title = Strings.current().prices,
            marginBottom = Dimen.extraSmallPadding,
        )

        Column(
            modifier = Modifier,
        )
        {
            Price(
                price =selectedPrice.price,
                priceLevels = priceLevels,
                selectedVat = selectedPrice.codeMWSt,
                windowSizeMode = windowSizeMode,
                countryId =profileCountryId,
                updatePrice = {
//                    updatePrice(it)
                },
                updateVatCode = {
//                    updateVatCode(it)
                }
            )

            PriceInCafe(
                priceInCafe =selectedPrice.priceInCafe,
                selectedVat2 =selectedPrice.codeMWSt2,
                priceLevels = priceLevels,
                windowSizeMode = windowSizeMode,
                countryId = profileCountryId,
                updatePriceInCafe = {
//                    updatePriceInCafe(it)
                },
                updateVatCode2 = {
//                    updateVatCode2(it)
                }
            )

        }

    }
}

@Composable
private fun GeneralPriceInfo(
    windowSizeMode: WindowSizeModeEnum,
    selectedPrice: GetSpecialPrice,
    updateInfo:(String,dynamic)->Unit,
) {
    val startDate= remember { mutableStateOf(MonthModel() ) }
    val endDate= remember { mutableStateOf(MonthModel() ) }
    Column()
    {
        Row()
        {
            DropDownItem(
                modifier = Modifier.margin(
                    right = Dimen.largePadding
                ),
                label = Strings.current().type,
                options =PriceTypeEnum.entries,
                itemWidth = Dimen.extraSemiMediumEditText,
                selectedItem =PriceTypeEnum.entries.find {
                      it.value==selectedPrice.type
                },
                displayText = {
                    if (it is PriceTypeEnum)
                        it.title else ""
                },
                onOptionClick = {
                    if (it is PriceTypeEnum){
                        updateInfo(ApiUtils.Field.type,it.value)
                    }
                }
            )

            CustomEditText(
                value =selectedPrice.name?:"",
                width = Dimen.semiLargeEditTextWidth,
                label = Strings.current().label,
                isRequired = false,
                onFocusOut = {
                    updateInfo(ApiUtils.Field.name,it)
                },
                onFocusIn = {},
                onInputChange = { it, _ ->

                }
            )
        }

        Row(
            modifier = Modifier
                .margin(bottom = Dimen.highLargePadding)
        )
        {
            CustomDropDown(
                modifier = Modifier
                    .margin(right = Dimen.largePadding),
                label = Strings.current().startDate,
                paddingTopBottom = 0.px,
                itemWidth = Dimen.normalEditTextWidth2,
                selectedDisplayContent = {
                    SpanText(
                        text = extractDate(selectedPrice.dateInterval?.from?:"")?:""  ,
                        modifier = Modifier
                            .fontSize(FontSizes.mediumFontSize)
                            .color(
                                Theme.TextPrimary.rgb
                            )
                            .fontWeight(FontWeight.Normal)
                            .fontFamily(FontFamily.Jakarta)
                    )

                },
                dropdownContent = {expanding->
                    DatePickerDialog(
                        selectedDay =startDate.value,
                        modifier = Modifier,
                        calendarData = getYearsData(
                            startYear = Constants.startYear,
                            endYear = Constants.endYear
                        ),
                        onSelectDay = {
                            startDate.value=it
                            expanding.value=false
                            val date=buildJsonObject {
                                put(ApiUtils.Field.from, monthModelToDateString(it))
                            }
                            updateInfo(ApiUtils.Field.dateInterval,date)
                        },
                        onBackgroundClick = {
                            expanding.value=false
                        },
                    )
                }
            )

            DropDownItem(
                modifier = Modifier,
                itemWidth = Dimen.normalEditTextWidth2,
                options = TimeIntervalEnum.entries,
                label = Strings.current().startTime,
                selectedItem = TimeIntervalEnum.entries.find {
                    it.value == selectedPrice.timeInterval?.from
                },
                displayText = {
                    if (it is TimeIntervalEnum)
                        it.title else ""
                },
                onOptionClick = {
                    if (it is TimeIntervalEnum){
                        val time=buildJsonObject {
                            put(ApiUtils.Field.from,it.value)
                        }
                        updateInfo(ApiUtils.Field.timeInterval,time)
                    }
                }
            )
        }

        if (selectedPrice.type==PriceTypeEnum.DISCOUNT.value){
            Row(
                modifier = Modifier
                    .margin(bottom = Dimen.highLargePadding)
            )
            {
                CustomDropDown(
                    modifier = Modifier
                        .margin(right = Dimen.largePadding),
                    label = Strings.current().endDate,
                    itemWidth = Dimen.normalEditTextWidth2,
                    paddingTopBottom = 0.px,
                    selectedDisplayContent = {
                        SpanText(
                            text = extractDate(
                                selectedPrice.dateInterval?.to?:"")?:""  ,
                            modifier = Modifier
                                .fontSize(FontSizes.mediumFontSize)
                                .color(
                                    Theme.TextPrimary.rgb
                                )
                                .fontWeight(FontWeight.Normal)
                                .fontFamily(FontFamily.Jakarta)
                        )
                    },
                    dropdownContent = {expanding->
                        DatePickerDialog(
                            selectedDay = endDate.value,
                            modifier = Modifier,
                            calendarData = getYearsData(
                                startYear = Constants.startYear,
                                endYear = Constants.endYear
                            ),
                            onSelectDay = {
                                endDate.value=it
                                expanding.value=false
                                val date=buildJsonObject {
                                    put(ApiUtils.Field.to, monthModelToDateString(it))
                                }
                                updateInfo(ApiUtils.Field.dateInterval,date)
                            },
                            onBackgroundClick = {
                                 expanding.value=false
                            },
                        )
                    }

                )

                DropDownItem(
                    modifier = Modifier,
                    itemWidth = Dimen.normalEditTextWidth2,
                    options = TimeIntervalEnum.entries,
                    label = Strings.current().endTime,
                    selectedItem =  TimeIntervalEnum.entries.find {
                        it.value == selectedPrice.timeInterval?.to
                    },
                    displayText = {
                        if (it is TimeIntervalEnum)
                            it.title else ""
                    },
                    onOptionClick = {
                        if (it is TimeIntervalEnum){
                            val time=buildJsonObject {
                                put(ApiUtils.Field.to,it.value)
                            }
                            updateInfo(ApiUtils.Field.timeInterval,time)
                        }

                    }
                )

            }

            SelectDays(
                modifier = Modifier
                    .margin(bottom = Dimen.highLargePadding),
                windowSizeMode = windowSizeMode,
                selectedDaysNumber =selectedPrice.weekDays?:0 ,
                onChangeDayCheckStatus = {
                    updateInfo(ApiUtils.Field.weekDays,it)
                }
            )

        }

    }

}